.dx{padding:0.5rem;}